module.exports = __webpack_public_path__ + "img/5.1ebd6529.jpg";